import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const SIRDPage = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      
      <main className="flex-grow">
        {/* Hero Section - Matches RIRD page style */}
        <section className="relative py-10 bg-blue-800">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <h1 className="text-2xl md:text-3xl font-bold text-white">State Institute of Rural Development & Panchayat Raj - SIRD&PR</h1>
              <div className="h-0.5 w-16 bg-white mt-2 mb-4"></div>
              <p className="text-white">
                Apex training institution for rural governance and development
              </p>
            </div>
          </div>
        </section>
        
        {/* Description Section */}
        <section className="py-6 bg-white">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto bg-blue-50 p-6 rounded-lg shadow-sm">
              <p className="text-gray-700 leading-relaxed">
                The State Institute of Rural Development & Panchayat Raj (SIRD&PR) is the apex training institution in the State 
                for training and capacity building of Elected Representatives and Officials of Rural Development and 
                Panchayat Raj Department on various rural development programmes and local governance. The Institute was found in 1990 and registered under Tamil Nadu Societies Registration Act, 1975. Presently the Institute is functioning in a 25 acre campus at Maraimalainagar, near Chennai.
              </p>
            </div>
          </div>
        </section>
        
        {/* Main Content */}
        <section className="py-6 bg-gray-50">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <div className="bg-white rounded-lg shadow-md p-6 mb-8">
                <h2 className="text-xl font-semibold text-blue-800 mb-4">Core Functions of SIRD&PR</h2>
                <ul className="list-disc pl-5 space-y-2 text-gray-700">
                  <li>Conceptualize, Design, Organize, Coordinate and Monitor training and Capacity Building activities for elected representatives of three tier Panchayat Raj Institutions.</li>
                  <li>Train Officials of Rural Development & Panchayat Raj Department and other line departments to effectively implement rural development programs.</li>
                  <li>Conduct training programs for Community Based Organizations (CBOs) and engage with the general public on rural governance initiatives.</li>
                  <li>Undertake research studies on various aspects of rural development and panchayat raj to inform policy and implementation.</li>
                </ul>
              </div>
              
              <div className="bg-white rounded-lg shadow-md p-6">
                <h2 className="text-xl font-semibold text-blue-800 mb-4">SIRD&PR Structure</h2>
                <p className="text-gray-700 mb-4">
                  The State Institute is headed by a senior officer in the rank of Additional Chief Secretary who is also the Vice-Chairman of SIRD&PR society. An officer in the cadre of Additional Director is in-charge for the training related activities and functioning as the Director of SIRD&PR.
                </p>
                
                <div className="mt-6">
                  <h3 className="text-lg font-medium text-blue-700 mb-3">Location and Facilities</h3>
                  <ul className="list-disc pl-5 space-y-2 text-gray-700">
                    <li>25-acre campus at Maraimalainagar, near Chennai</li>
                    <li>Modern training halls and conference facilities</li>
                    <li>Computer lab and digital learning center</li>
                    <li>Library and resource center</li>
                    <li>Residential accommodation for trainees</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
};

export default SIRDPage;